// extracted by mini-css-extract-plugin
export default {"nologin":"Collect_nologin__F8stY","blank":"Collect_blank__3zzWi","blank_img":"Collect_blank_img__Fj06B","text":"Collect_text__luVF7","right_control":"Collect_right_control__1zNyN"};